import { admin_routes as routes } from "../../constants/api-routes";
import { FormUtils } from "../../utils/_FormUtils";
import { API } from "../../utils/_HttpUtils";

const signIn = (username, password, captcha = "",  c_key = "") =>
    new API().send(
        "POST",
        routes.signIn,
        {
            username,
            password,
            ...(captcha && {captcha}),
            ...(c_key && {c_key}),
        },
        FormUtils.captchaHeader()
    );

export { signIn };
